import { Component, Input, OnInit } from '@angular/core';
import { LocalizedRouterService } from '../../../localized-router.service';
import { SearchService } from '../searchbar/search.service';
import { Utils } from '../../../utils/utils';

@Component({
    selector: 'app-banner',
    templateUrl: './banner.component.html',
    styleUrls: ['./banner.component.css'],
    standalone: false
})
export class BannerComponent implements OnInit {

  @Input() imageUrl: string = '';
  // ISO country code, e.g. "al". Resolved to a database id at click time so
  // the link survives any reseeding that may shift autoincrement values.
  @Input() country: string = '';
  // Region display name as stored in the database, e.g. "Berat". Matched
  // case-insensitively against Region.name.
  @Input() region: string = '';
  protected Utils = Utils;

  constructor(
    private localizedRouter: LocalizedRouterService,
    private searchService: SearchService,
  ) { }

  ngOnInit() {
  }

  // Lowercase + strip diacritics so "Vlore" matches "Vlorë", "Shkoder"
  // matches "Shkodër", etc.
  private static normalize(value: string): string {
    return value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  async search() {
    if (!this.country || !this.region) {
      this.localizedRouter.navigate(['search']);
      return;
    }

    try {
      const countries = await this.searchService.getCountries(false);
      const countryMatch = countries.find(
        (c) => BannerComponent.normalize(c.code ?? '') === BannerComponent.normalize(this.country),
      );
      if (!countryMatch?.id) {
        console.warn(`Banner: country code "${this.country}" not found in DB`);
        this.localizedRouter.navigate(['search']);
        return;
      }

      const regions = await this.searchService.getRegions(countryMatch.id, false);
      const regionMatch = regions.find(
        (r) => BannerComponent.normalize(r.name ?? '') === BannerComponent.normalize(this.region),
      );

      const queryParams: Record<string, string> = {
        country: countryMatch.id,
        sort: 'averageRate-desc',
        language: 'wl',
      };
      if (regionMatch?.id) {
        queryParams['region'] = regionMatch.id;
      } else {
        console.warn(
          `Banner: region "${this.region}" not found for country "${this.country}", navigating with country filter only`,
        );
      }

      this.localizedRouter.navigate(['search'], { queryParams });
    } catch (err) {
      console.error('Banner: failed to resolve country/region ids', err);
      this.localizedRouter.navigate(['search']);
    }
  }

}
